import CustomHead from 'components/commons/CustomHead'
import Template from 'components/LP/LP202407/AWSCodePipeline'

const AWSCodePipeline: React.FC = () => {
  return (
    <>
      <CustomHead
        keyword={'AWS CodePipeline パイプライン CI/CD デプロイ'}
        image={'https://aitria.co.jp/img/ogp_logo.png'}
        url={'https://aitria.co.jp/services/awscodepipeline/'}
        title="AWS CodePipeline | サービス | Aitria（アイトリア）"
        description="AWS CodePipeline導入支援は、CI/CDパイプラインを効率的に構築し、自動化と信頼性を向上させることで、迅速なソフトウェアデリバリーを実現します。AWSクラウドを活用し、開発からデプロイまでのプロセスを一貫して管理することで、開発チームの生産性を最大化します。"
      />
      <Template />
    </>
  )
}

export default AWSCodePipeline
